<template>
    <div
        class="team-block"
    >
        <div
            :class="[member.type === 'team' ? 'member' : 'heading', 'box', member.className]"
            v-for="member in teamTitled"
        >
            <div class="content" v-if="member.type === 'team'">
                <div
                    class="image-holder"
                >
                    <div
                        class="image-gabarit"
                        :style="{
                            backgroundImage: `url(${member.image.url || '/assets/empty-image.svg'})`
                        }"
                    />
                    <img
                        :src="member.image.url"
                        :alt="member.image.alt"
                        :title="member.image.title"
                        class="seo-image"
                    />
                </div>
                <p class="name">{{member.firstname}} {{member.lastname}}</p>
                <p class="role">{{member.role}}</p>
                <p class="description" v-html="member.description"/>
            </div>
            <IconPlus
                v-if="member.type === 'team'"
                @click.native="openPopin(member)"
            />
            <h2 v-if="member.type !== 'team'">{{layout.title}}</h2>
        </div>
    </div>
</template>
<script>
import IconPlus from '@/components/IconPlus'
import {popin} from '@/store/index.js'
export default {
    components: {
        IconPlus
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        teamTitled() {
            const {team} = this.layout
            team.splice(0, 0, {
                className: 'small'
            })
            team.splice(2, 0, {
                className: 'medium'
            })
            team.splice(4, 0, {
                className: 'large'
            })
            return team
        }
    },
    methods: {
        openPopin(member) {
            popin.data = member
            popin.state = true
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.team-block
    margin-top: 10%
    margin-bottom: 10%
    display: flex
    flex-wrap: wrap
    flex-direction: row
    justify-content: flex-end
    &+.team-block
        margin-top: -10%
.box
    width: 33.33%
    height: 896px
    border-right: 1px solid #e5e5e5
    margin-bottom: 80px
    display: flex
    flex-direction: column
    padding-left: 3.75%
    padding-right: 3.75%
    @include media-breakpoint-down($hd)
        width: 50%
    @include media-breakpoint-down($md)
        width: 100%
        height: auto
        padding-left: 9.6%
        padding-right: 9.6%
        border-left: none
    // &:nth-child(3n+0)
    //     border-left: none
.heading
    // position: absolute
    // right: 0
    // @include media-breakpoint-down($md)
    position: relative
    &.small
        display: none
    &.medium
        display: none
    @include media-breakpoint-down($hd)
        &.large
            display: none
        &.medium
            display: flex
    @include media-breakpoint-down($md)
        &.medium
            display: none
        &.small
            display: flex
h2
    font-size: 86px
    color: #646873
    font-weight: 500
    transform: translateY(-50%) translateX(-50%) rotate(-90deg)
    position: absolute
    left: 50%
    top: 50%
    @include media-breakpoint-down($md)
        font-size: 36px
        position: static
        transform: none
        left: initial
        top: initial
.content
    flex: 1
    p
        font-size: 28px
        @include media-breakpoint-down($md)
            font-size: 17px
        &.name
            font-weight: 500
            color: #ff2b2a
            margin-bottom: .3em
            letter-spacing: -0.03125em
        &.role
            font-weight: 500
            letter-spacing: -0.03125em
        &.description
            margin-top: 2.4em
            line-height: 1.2
            @include media-breakpoint-down($md)
                margin-top: 1.2em
                margin-bottom: 1.2em
.image-holder
    width: 312px
    margin-top: 13px
    margin-bottom: 3.75em
    max-width: 100%
    .image-gabarit
        padding-bottom: 97.4193548387%
        background-position: 50% 50%
        background-repeat: no-repeat
        background-size: cover
svg
    width: 30px
    height: 30px
    cursor: pointer
    /deep/ path
        fill: #ff3939
</style>
